module.exports = __webpack_public_path__ + "static/media/House1.eb6c8bee.jpeg";